import React from 'react';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { FREE_OF_CHARGE_CATEGORY_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import FreeOfChargeCategoryForm from './FreeOfChargeCategoryForm';
import { postFreeOfChargeCategory } from '../../../../actions/sales/FreeOfChargeCategory';

const NewFreeOfChargeCategory = ({
  breadcrumbs,
  dispatchPostFreeOfChargeCategory,
}) => {
  const onSubmit = (formValues) => {
    const subcats = Array.isArray(formValues.freeOfChargeSubCategoryList)
      ? formValues.freeOfChargeSubCategoryList
      : [];

    const categoryAuthorizers = Array.isArray(
      formValues.freeOfChargeSubCategoryUserList,
    )
      ? formValues.freeOfChargeSubCategoryUserList
      : [];

    if (subcats.length === 0 && categoryAuthorizers.length === 0) {
      toastr.error(
        'Error',
        'Si no agregas subcategorías, debes agregar al menos un autorizador de la categoría.',
      );
      return;
    }

    if (subcats.length > 0 && categoryAuthorizers.length > 0) {
      toastr.error(
        'Error',
        'Si agregas subcategorías, no debes seleccionar autorizadores a nivel de categoría. Elimina los autorizadores de la categoría o remueve las subcategorías.',
      );
      return;
    }

    const categoryName =
      formValues.name || formValues.categoryName || 'Categoría';

    let freeOfChargeSubCategoryList = [];

    if (subcats.length > 0) {
      freeOfChargeSubCategoryList = subcats.map((subCategory) => ({
        name: subCategory.name,
        active: true,
        freeOfChargeSubCategoryUserList:
          subCategory.freeOfChargeSubCategoryUserList.map((authorizer) => ({
            customerId: authorizer.value,
            active: true,
          })),
      }));
    } else {
      freeOfChargeSubCategoryList = [
        {
          name: categoryName,
          active: true,
          freeOfChargeSubCategoryUserList: categoryAuthorizers.map(
            (authorizer) => ({
              customerId: authorizer.value,
              active: true,
            }),
          ),
        },
      ];
    }

    const newFormValues = {
      ...formValues,
      freeOfChargeSubCategoryList,
      active: formValues.active || true,
    };

    dispatchPostFreeOfChargeCategory(newFormValues);
  };

  const content = (
    <FreeOfChargeCategoryForm
      onSubmit={onSubmit}
      initialValues={{
        active: true,
      }}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Categoría de Servicio a Título Gratuito"
      subtitle="Crear categoría de servicio a título gratuito"
      content={content}
    />
  );
};

NewFreeOfChargeCategory.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostFreeOfChargeCategory: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostFreeOfChargeCategory: postFreeOfChargeCategory,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Categoría Para Servicios a Título Gratuito',
      href: FREE_OF_CHARGE_CATEGORY_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewFreeOfChargeCategory);
